import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ReactionsSummaryDetailComponent} from './reactions-summary-detail.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';



@NgModule({
  declarations: [
    ReactionsSummaryDetailComponent
  ],
  imports: [
    CommonModule,
    NgbModule
  ],
  exports: [
    ReactionsSummaryDetailComponent
  ],
  entryComponents:[ReactionsSummaryDetailComponent],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class ReactionsSummaryDetailModule { }
